// Machine-drafted — review with a native speaker before launch.
const engagement = {
	engagement: {
		// Engagement page
		title: 'Interacción',
		last7Days: 'Últimos 7 días',
		last15Days: 'Últimos 15 días',
		last30Days: 'Últimos 30 días',
		last2Months: 'Últimos 2 meses',
		last6Months: 'Últimos 6 meses',
		lastYear: 'Último año',
		allCards: 'Todas las tarjetas',
		statContactEngagement: 'Interacción de contactos',
		statEmailsOpened: 'Correos abiertos',
		statCardsOpened: 'Tarjetas abiertas',
		statTotalReactions: 'Reacciones totales',
		statTotalComments: 'Comentarios totales',
		statTotalDownloads: 'Descargas totales',
		cardEngagement: 'Interacción de la tarjeta',
		noSentCards: 'No se encontraron tarjetas enviadas. Envía una tarjeta para ver los datos de interacción.',
		untitled: 'Sin título',
		cardAlt: 'Tarjeta',
		loading: 'Cargando...',
		analytics: 'Analíticas',
		reactions: 'Reacciones',
		noReactions: 'Sin reacciones',
		comments: 'Comentarios (%{count})',
		anonymous: 'Anónimo',
		noComments: 'Sin comentarios',
		// Contacts engagement list
		viewContacts: 'Ver contactos',
		cardStats: 'Estadísticas de tarjetas',
		mostEngagedContacts: 'Contactos más comprometidos',
		noContactsYet: 'Aún no tienes ningún contacto.',
		tooltipCardsOpened: 'Total de tarjetas abiertas por este contacto',
		tooltipCardsSent: 'Total de tarjetas enviadas a este contacto',
		// Activities
		typeLabel: 'Tipo',
		optionClicks: 'Clics',
		impression: 'Impresión',
		filterLabel: 'Filtro',
		optionLast10Days: 'Últimos 10 días',
		optionLast7Days: 'Últimos 7 días',
		newClick: '‘Nombre de imagen’ recibió un nuevo clic',
		justNow: 'Justo ahora',
		messengerRedirect: 'Alguien desde Messenger fue redirigido a www.cardclan.io',
		conversion: 'Conversión',
		sourceLabel: 'Fuente: %{source}',
		newImpression: '‘Nombre de imagen’ recibió una nueva impresión',
		oneHour: '1 h',
		twitterRedirect: 'Alguien desde Twitter fue redirigido a www.cardclan.io',
	} as Record<string, string>,
};
export default engagement;
